// Canonical moment.js date/time format strings.
// Mirrors the backend Ruby constants in config/initializers/global_constants.rb
// so that dates/times render consistently across Rails views, React, and Angular.
//
// NOTE: meridian (am/pm) is uppercase everywhere to stay consistent.

// --- numeric (slash) formats ---
export const DATE = "M/D/YYYY"; // DATE_FORMAT            %-m/%-d/%Y
export const DATE_WO_YEAR = "M/D"; // DATE_FORMAT_WO_YEAR    %-m/%-d
export const DATETIME = "M/D/YYYY h:mmA"; // DATETIME_FORMAT        %-m/%-d/%Y %-I:%M%p
export const DATETIME_W_DAY = "dddd, M/D/YYYY h:mmA"; // DATETIME_FORMAT_W_DAY
export const TIME = "h:mmA"; // TIME_FORMAT           %-I:%M%p

// --- verbose (word) formats ---
export const VERBOSE_DATE = "MMM D, YYYY"; // VERBOSE_DATE_FORMAT            %b %-d, %Y
export const VERBOSE_DATE_WO_YEAR = "MMM D"; // VERBOSE_DATE_FORMAT_WO_YEAR    %b %-d
export const VERBOSE_DATE_W_DAY = "ddd, MMM D, YYYY"; // VERBOSE_DATE_FORMAT_W_DAY
export const VERBOSE_DATE_W_DAY_WO_YEAR = "ddd, MMM D"; // VERBOSE_DATE_FORMAT_W_DAY_WO_YEAR
export const VERBOSE_DATETIME = "ddd, MMM D, YYYY h:mmA"; // VERBOSE_DATETIME_FORMAT
export const VERBOSE_DATETIME_WO_YEAR = "MMM D, h:mmA"; // VERBOSE_DATETIME_FORMAT_WO_YEAR
export const VERBOSE_DATETIME_W_DAY_WO_YEAR = "ddd, MMM D, h:mmA"; // VERBOSE_DATETIME_FORMAT_W_DAY_WO_YEAR
export const VERBOSE_DATETIME_ORDINAL = "dddd MMMM Do h:mmA"; // full weekday + month, ordinal day, no year
export const MONTH_YEAR = "MMMM YYYY"; // VERBOSE_MONTH_YEAR
